import { createContext, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useMobile } from "../../../context/MobileContext";
import { Recharge, Withdraw } from "../components";

const WalletContext = createContext({
  walletItems: [],
  walletActiveTab: "",
  rechargeRecordItems: [],
  rechargeRecordActiveTab: "",
  setRechargeRecordActiveTab: () => {},
  withdrawRecordItems: [],
  withdrawRecordActiveTab: "",
  setWithdrawRecordActiveTab: () => {},
});

export const WalletContextProvider = ({ children }) => {
  const { t } = useTranslation();
  const { isMobile } = useMobile();
  const [params] = useSearchParams();

  const walletItems = [
    { label: t("normal.recharge"), key: "recharge", children: <Recharge /> },
    { label: t("normal.withdraw"), key: "withdraw", children: <Withdraw /> },
  ];
  const [walletActiveTab, setWalletActiveTab] = useState(params.get("tab") || walletItems[0].key);

  const rechargeRecordItems = isMobile
    ? [
        { value: 0, text: t("normal.all") },
        { value: 2, text: t("normal.success") },
      ]
    : [
        { label: t("normal.all"), key: 0 },
        { label: t("normal.success"), key: 2 },
      ];
  const [rechargeRecordActiveTab, setRechargeRecordActiveTab] = useState(
    isMobile ? rechargeRecordItems[0].value : rechargeRecordItems[0].key,
  );

  const withdrawRecordItems = isMobile
    ? [
        { value: 0, text: t("normal.all") },
        { value: 2, text: t("normal.success") },
        { value: 1, text: t("normal.rejected") },
      ]
    : [
        { label: t("normal.all"), key: 0 },
        { label: t("normal.success"), key: 2 },
        { label: t("normal.rejected"), key: 1 },
      ];
  const [withdrawRecordActiveTab, setWithdrawRecordActiveTab] = useState(
    isMobile ? withdrawRecordItems[0].value : withdrawRecordItems[0].key,
  );

  return (
    <WalletContext.Provider
      value={{
        walletItems,
        walletActiveTab,
        rechargeRecordItems,
        rechargeRecordActiveTab,
        setRechargeRecordActiveTab,
        withdrawRecordItems,
        withdrawRecordActiveTab,
        setWithdrawRecordActiveTab,
      }}
    >
      {children}
    </WalletContext.Provider>
  );
};

export const useWallet = () => {
  const Value = useContext(WalletContext);
  return Value;
};
